/** 匠盟 EEPROM 休眠档位：UI 秒数 = 档位 × 10 */

export const JIANGMENG_SLEEP_LEGACY_MIN_SEC = 10;
export const JIANGMENG_SLEEP_LEGACY_MAX_SEC = 900;
export const JIANGMENG_SLEEP_LEGACY_DEFAULT_LEVEL = 1;

export const ALPHA6_SLEEP_MIN_SEC = 600;
export const ALPHA6_SLEEP_MAX_SEC = 1800;
export const ALPHA6_SLEEP_STEP_SEC = 10;
/** 设备默认档位 60 → 600s */
export const ALPHA6_SLEEP_DEFAULT_LEVEL = 60;

export function clampJiangmengSleepLevel(
  level: number,
  isAlpha6: boolean
): number {
  const n = Math.round(Number(level));
  if (!Number.isFinite(n)) {
    return isAlpha6
      ? ALPHA6_SLEEP_DEFAULT_LEVEL
      : JIANGMENG_SLEEP_LEGACY_DEFAULT_LEVEL;
  }
  if (isAlpha6) {
    return Math.max(
      ALPHA6_SLEEP_MIN_SEC / 10,
      Math.min(ALPHA6_SLEEP_MAX_SEC / 10, n)
    );
  }
  return Math.max(1, Math.min(JIANGMENG_SLEEP_LEGACY_MAX_SEC / 10, n));
}

export function jiangmengSleepLevelToSeconds(
  level: number,
  isAlpha6: boolean
): number {
  const clamped = clampJiangmengSleepLevel(level, isAlpha6);
  const sec = clamped * 10;
  if (isAlpha6) {
    const stepped =
      Math.round(sec / ALPHA6_SLEEP_STEP_SEC) * ALPHA6_SLEEP_STEP_SEC;
    return Math.max(
      ALPHA6_SLEEP_MIN_SEC,
      Math.min(ALPHA6_SLEEP_MAX_SEC, stepped)
    );
  }
  return Math.max(
    JIANGMENG_SLEEP_LEGACY_MIN_SEC,
    Math.min(JIANGMENG_SLEEP_LEGACY_MAX_SEC, sec)
  );
}

export function jiangmengSleepSecondsToLevel(
  seconds: number,
  isAlpha6: boolean
): number {
  const sec = Number(seconds);
  if (!Number.isFinite(sec)) {
    return isAlpha6
      ? ALPHA6_SLEEP_DEFAULT_LEVEL
      : JIANGMENG_SLEEP_LEGACY_DEFAULT_LEVEL;
  }
  if (isAlpha6) {
    const stepped =
      Math.round(sec / ALPHA6_SLEEP_STEP_SEC) * ALPHA6_SLEEP_STEP_SEC;
    const clampedSec = Math.max(
      ALPHA6_SLEEP_MIN_SEC,
      Math.min(ALPHA6_SLEEP_MAX_SEC, stepped)
    );
    return clampedSec / 10;
  }
  return clampJiangmengSleepLevel(Math.round(sec / 10), false);
}
